import {
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type InvalidateWinnersParams = Static<typeof InvalidateWinnersParamsSchema>;
export const InvalidateWinnersParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: LotteryDrawSchema.properties.id,
  },
  { additionalProperties: false, $id: 'InvalidateWinnersParamsSchema' }
);

export type InvalidateWinnersBody = Static<typeof InvalidateWinnersBodySchema>;
export const InvalidateWinnersBodySchema = Type.Object(
  {
    winners: Type.Array(
      Type.Object(
        {
          partyUid: Type.String(),
        },
        { additionalProperties: false }
      )
    ),
  },
  { additionalProperties: false, $id: 'InvalidateWinnersBodySchema' }
);

export type InvalidateWinnersResponse = Static<typeof InvalidateWinnersResponseSchema>;
export const InvalidateWinnersResponseSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'InvalidateWinnersResponseSchema' }
);
